import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/userLoginSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterByType = () => {
  const dispatch = useDispatch();
  const { typeOptions, selectedTypeOption } = useSelector((state) => state.loginReport);

  return (
    <div className="filters__wrapper">
      <div className="select-box-no-width filters__wrapper__type">
        <p>Type</p>
        <MultiSelectDropdown
          placeholder="Select Type"
          options={typeOptions}
          selectedFilters={selectedTypeOption}
          onSelectChange={(data) => dispatch(actionCreators.updateType(data))}
          includeFilter={false}
        />
      </div>
    </div>
  );
};

export default FilterByType;
